import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { removeCat } from "../../../../store/updateData";

export const deleteCat = async (agree: boolean | null, params: stdObject) => {
  const {
    t,
    dispatch,
    setWindowValues,
    modalData,
    setModalData2,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;
  if (agree) {
    setMsg2("loading");
    let payloadDeleteCat: stdObject = {
      id: modalData.id,
    };
    console.log("payloadDeleteCat: ", payloadDeleteCat);
    const responseDeleteCat: stdObject = await sendData({
      endPoint: "deleteCat",
      payload: payloadDeleteCat,
      logoutAction,
    });

    console.log("responseDeleteCat: ", responseDeleteCat);
    if (responseDeleteCat.success && responseDeleteCat.status) {
      dispatch(
        removeCat({
          type: responseDeleteCat.id,
        }),
      );

      closeMsg(2);
      closeMsg();
      setWindowValues({});
    } else {
      setMsg2("error");
    }
  } else {
    setMsg2("custom2");
    setModalData2({
      code: "warning",
      title: t("p.askDeleteCat"),
      buttons: [
        {
          label: t("p.delete"),
          onClick: () => deleteCat(true, params),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    });
  }
};
